import { redirect, useNavigation } from "react-router";
import { getUserInfo } from "../api/user";
import { API_LINKS } from "../constants/api";
import HeaderStandard from "../components/layouts/HeaderStandard";
import SmallScreenWarningModal from "../components/Modal/SmallScreenWarningModal";
export const loginLoader = async () => {
  try {
    const userInfo = await getUserInfo();
    if (userInfo) {
      const returnurl = new URLSearchParams(window.location.search).get(
        "returnurl",
      );
      return redirect(returnurl ? returnurl : "/");
    }
  } catch (_error) {
    return null;
  }
};

export default function Login() {
  const navigation = useNavigation();
  return (
    <div className="bg-logo text-white h-100 d-flex flex-column">
      <HeaderStandard />
      <div className="row justify-content-center w-100 g-0 flex-grow-1 align-content-center">
        <div
          className={`col col-xl-8 p-3 d-flex flex-column align-items-center gap-4${
            navigation.state === "loading" ? " loading" : ""
          }`}
        >
          <h1
            className="text-white display-1 text-center mb-3"
            style={{ fontSize: "2.75rem" }}
          >
            Velkommen til <br />
            Advokatsamfundets indberetningsportal
          </h1>
          <p className="text-center px-6 w-75 fw-light lh-lg">
            Som advokat har du pligt til løbende indsende oplysninger til
            Advokatsamfundet. Denne indberetningsportal skal du bruge til
            klientkontoerklæring, tilsynserklæring og indberetning af
            obligatorisk efteruddannelse. Du kan læse mere om Regler for
            advokater på{" "}
            <a
              target="_blank"
              className="link-white fw-semibold"
              rel="noreferrer"
              href="https://www.advokatsamfundet.dk/regler-for-advokater/"
            >
              advokatsamfundet.dk
            </a>
          </p>
          <a
            href={`${
              API_LINKS.baseUrl
            }/Authentication/loginMitId?subscription-key=${
              import.meta.env.OCP_APIM_SUBSCRIPTION_KEY
            }`}
            className="btn btn-light btn-lg fw-semibold col-4"
          >
            Login med MitID
          </a>
          {/* {import.meta.env.DEV && (
            <a
              href="/"
              id="dev-login-bypass"
              className="btn btn-outline-light btn-lg fw-semibold col-4"
              aria-label="Fortsæt uden MitID i udvikling"
            >
              Fortsæt uden MitID (dev)
            </a>
          )} */}
        </div>
      </div>
      <footer className="text-light small fw-light text-center py-5 px-3 opacity-75">
        Advokatsamfundet - Kronprinsessegade 28 - 1306 København K -{" "}
        <a
          target="_blank"
          className="link-white fw-semibold"
          rel="noreferrer"
          href="https://www.advokatsamfundet.dk/"
        >
          www.advokatsamfundet.dk
        </a>
      </footer>
      <SmallScreenWarningModal />
    </div>
  );
}
